// Shared within this browser screen; no polling or server-side lease is needed.
export const INITIAL_AREA_DAMAGE_EVENT = 'persistent-spell:initial-damage';
const active = new Set();
const completed = new Set();
const keyFor = ({ campaignId, sourceCombatantId, castId }) => JSON.stringify([campaignId, String(sourceCombatantId), castId]);
export const isInitialAreaDamageRolling = detail => active.has(keyFor(detail)) || completed.has(`${keyFor(detail)}:${detail.requestId}`);
export function initialAreaDamage(detail) {
  const key = keyFor(detail);
  if (detail.active) active.add(key); else active.delete(key);
  if (detail.completed && detail.requestId) {
    completed.add(`${key}:${detail.requestId}`);
    if (completed.size > 100) completed.delete(completed.values().next().value);
  }
  window.dispatchEvent(new CustomEvent(INITIAL_AREA_DAMAGE_EVENT, { detail }));
}
